import { Button, Alert, Group, Text } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { Link } from 'react-router-dom';
import { useSubscriptionFeatures } from '../hooks/useSubscriptionFeatures';

/**
 * Banner component that displays subscription status information 
 * and upgrade prompts based on the user's subscription tier
 */
export function ConversationLimitBanner() {
  const {
    isTrialActive,
    trialDaysRemaining,
    isPremium,
  } = useSubscriptionFeatures();

  // Show trial banner (highest priority)
  if (isTrialActive) {
    return (
      <Alert
        color="blue"
        icon={<IconInfoCircle size={16} />}
        title="Voice Connect Trial"
        withCloseButton={false}
        mb="md"
      >
        <Group justify="space-between" align="center">
          <Text size="sm">
            You have {trialDaysRemaining} {trialDaysRemaining === 1 ? 'day' : 'days'} left in your Voice Connect trial
          </Text>
          <Button
            component={Link}
            to="/settings/subscription"
            size="xs"
            variant="light"
          >
            Upgrade Now
          </Button>
        </Group>
      </Alert>
    );
  }

  // Don't show any banner for Premium users
  if (isPremium) {
    return null;
  }

  // Show upgrade banner for non-premium users
  return (
    <Alert
      color="blue"
      icon={<IconInfoCircle size={16} />}
      title="Upgrade to Premium"
      withCloseButton={false}
      mb="md"
    >
      <Group justify="space-between" align="center">
        <Text size="sm">
          Voice Connect for voice conversations and advanced features
        </Text>
        <Button
          component={Link}
          to="/settings/subscription"
          size="xs"
          variant="filled"
          className="bg-[#C2A4D6] hover:bg-[#B390C9] text-white rounded-full"
        >
          View Plans
        </Button>
      </Group>
    </Alert>
  );
}